module.exports = __webpack_public_path__ + "static/img/BongaCams.5d18f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plataformas/BongaCams.png
// module id = 99J2
// module chunks = 1